module.exports = __webpack_public_path__ + "static/Aviva-Toy-Wedding-ae4ef14990ac57b72df7aeaaf526770a.mp4";